// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PredictedField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { isEmpty, isNil, find, map, indexOf, remove, isBoolean } from 'lodash/fp';
import { observable, computed, action, toJS } from 'mobx';

import { DATA_TYPES } from 'logic/data/Izenda.ReportDesignerConstants';
import constants from 'logic/data/Izenda.PredictedFieldConstants';

export default class PredictedField {
  @observable id = null;
  @observable name = '';
  @observable selectedModel = '';
  @observable inputFeatures = [];
  @observable selectedModelType = '';
  @observable tempId = null;
  @observable targetValue = '';
  @observable accuracy = '';
  @observable relationColumn = '';
  @observable percentError = '';
  clone() {
    const data = toJS(this);
    const cloned = new PredictedField();
    cloned.readInitialData(data, data.type);
    return cloned;
  }

  @action
  readInitialData(data: any, type: string) {
    data = data || {};

    this.name = data.name || '';
    this.functionName = data.functionName || constants.FUNCTION_NAME.NONE;
    this.expression = data.expression || '';
    this.izendaDataType = data.izendaDataType || null;
    this.isRunningField = data.isRunningField || false;
    this.isCompositeField = data.isCompositeField || false;
    this.tempId = data.tempId;
    this.id = data.id || null;
    this.querySourceId = data.querySourceId || '';
    this.fieldDataType = data.fieldDataType || '';
    this.type = type || constants.PM_TYPES.ADD;
    this.previewRecord = data.previewRecord || null;
    this.format = data.format || {};
    this.hasSupportDefaultTotal = isBoolean(data.hasSupportDefaultTotal) ? data.hasSupportDefaultTotal : true;
    this.formatDataType = data.formatDataType || '';
    this.canSetSubtotal = isBoolean(data.canSetSubtotal) ? data.canSetSubtotal : true;

    return Promise.resolve();
  }

    /**
   * Change function name
   * @param {string} value
   */

  changeFieldName(value : string){
    this.name = value;
  };

}


// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.PredictedField.js